module.exports = __webpack_public_path__ + "img/cart.76f4bc99.svg";